import * as Sentry from "@sentry/node";
import getConfig from "next/config";

const { SENTRY_DSN } = getConfig().publicRuntimeConfig;

class Logger {
    public error(err: Error | string) {
        console.error(...arguments);
        if (typeof err === "string") {
            this._captureMessage(err, Sentry.Severity.Error);
        } else {
            this._captureException(err, Sentry.Severity.Error);
        }
    }

    private _captureException(err: Error, level: Sentry.Severity) {
        if (!SENTRY_DSN) {
            return;
        }

        Sentry.captureException(err, {
            level,
        });
    }

    private _captureMessage(message: string, level: Sentry.Severity) {
        if (!SENTRY_DSN) {
            return;
        }
        Sentry.captureException(message, {
            level,
        });
    }
}

export default Logger;
